import { ViewerComponent } from '@app/client/viewer/viewer.component';
import { viewerRoutesNames } from '@app/client/viewer/viewer.routes.names';

export const VIEWER_ROUTES = [
  {
    path: viewerRoutesNames.EMPTY_URL,
    data: { moduleName: 'ViewerModule' },
    component: ViewerComponent,
  },
];
